/* global listRequestsUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import Alert from 'CommonComponents/Alert';

export default function HasPendingRequestWarning(props) {
    return (
        <Alert className="tw-my-2" type="warning">
            This budget currently has a pending approval request and cannot be edited. See{' '}
            <a href={props.url} target={'_blank'} rel="noreferrer" className="tw-text-blue-500">
                {' '}
                here
            </a>{' '}
            for pending requests.
        </Alert>
    );
}

if (document.getElementById('hasPendingRequestWarning')) {
    var rootEl = document.getElementById('hasPendingRequestWarning');
    ReactDOM.render(
        <App>
            <HasPendingRequestWarning url={listRequestsUrl} />
        </App>,
        rootEl,
    );
}
